import React from "react";
import { useTranslation } from 'react-i18next';
import "./footer.css";
import cvFile from "../../assets/CV-Bram-Platier.pdf";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer__container container">
        <div className="footer__content">
          <h3 className="footer__title">{t('footer_title') || "Let's Work Together"}</h3>
          <p className="footer__subtitle">
            {t('footer_subtitle') || "Have a project or question? Feel free to reach out!"}
          </p>
        </div>

        <div className="footer__links">
          <div className="footer__group">
            <h4 className="footer__heading">{t('quick_links') || 'Quick Links'}</h4>
            <ul className="footer__list">
              <li><a href="#home">{t('home')}</a></li>
              <li><a href="#about">{t('about')}</a></li>
              <li><a href="#portfolio">{t('portfolio')}</a></li>
              <li><a href="#contact">{t('contact')}</a></li>
            </ul>
          </div>

          <div className="footer__group">
            <h4 className="footer__heading">{t('social_media') || 'Social Media'}</h4>
            <div className="footer__socials">
              <a href="https://github.com/bramplatier" target="_blank" rel="noopener noreferrer" className="footer__social">
                <i className="icon-github"></i> GitHub
              </a>
              <a href="https://www.linkedin.com/in/bram-platier/" target="_blank" rel="noopener noreferrer" className="footer__social">
                <i className="icon-linkedin"></i> LinkedIn
              </a>
              <a href="mailto:bramplatier@gmail.com" className="footer__social">
                <i className="icon-mail"></i> Email
              </a>
            </div>
          </div>
        </div>

        <div className="footer__cta">
          <a href={cvFile} download="CV-Bram-Platier.pdf" className="btn btn-secondary" data-track="Download CV (Footer)">
            {t('download_cv') || 'Download CV'}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
